import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import {
  RaisedButton,
} from 'material-ui';
import { change as onChange } from 'redux-form';
import { connect } from 'react-redux';
import { translate } from 'admin-on-rest';

const styles = {
  list: {
    display: 'flex',
    listStyleType: 'none',
  },
  image: {
    margin: '0.5rem',
    maxHeight: '10rem',
  },
  wrapper: {
    display: 'flex',
    flexFlow: 'row wrap',
    alignItems: 'center',
  },
};

export const PromoteImageButton = translate(({ elStyle = {}, record, translate, source, change, src, title }) => { // eslint-disable-line no-shadow
  const sourceValue = get(record, source);
  if (!sourceValue) {
    return <div />;
  }

  if (Array.isArray(sourceValue)) {
    const style = {
      ...styles.list,
      ...elStyle,
    };
    return (
      <ul style={style}>
        {sourceValue.map((file, index) => {
          const titleValue = get(file, title) || title;
          const srcValue = get(file, src) || title;

          return (
            <li
              key={index} // eslint-disable-line
            >
              <img
                alt={titleValue}
                title={titleValue}
                src={srcValue}
                style={styles.image}
              />
            </li>
          );
        })}
      </ul>
    );
  }

  const titleValue = get(record, title) || title;

  return (
    <div style={styles.wrapper}>
      <img
        title={titleValue}
        alt={titleValue}
        src={sourceValue}
        style={styles.image}
      />
      <RaisedButton onClick={() => change('record-form', 'mainImageUrl.src', record.provisionalImageUrl.src)} label={translate('promoteToMainImage')} />
    </div>
  );
});

PromoteImageButton.defaultProps = {
  addField: true,
};

PromoteImageButton.propTypes = {
  addField: PropTypes.bool, // eslint-disable-line
  elStyle: PropTypes.object,
  record: PropTypes.object,
  source: PropTypes.string.isRequired,
  title: PropTypes.string,
};

export default connect((state) => state, { change: onChange })(PromoteImageButton);
